import axiosInstance, { axiosInstanceWithToken } from "./interceptor";

const controllers: { [key: string]: AbortController } = {};

export const getData: any = (url: string, filters?: any) => {
  if (controllers[url]) {
    controllers[url].abort();
  }

  // Create a new AbortController for this request and store it by URL
  const controller = new AbortController();
  controllers[url] = controller;
  const { signal } = controller;

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url, {
        params: filters,
        signal,
      })
      .then((res: any) => {
        resolve(res);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};
export const postData: any = (url: string, data: any) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((res: any) => {
        resolve(res);
      })
      .catch((error: any) => {
        reject(error);
        return error;
      });
  });
};
export const patchData: any = (url: string) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .patch(url)
      .then((res: any) => {
        resolve(res);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const putData: any = (url: string, data: any) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((res: any) => {
        resolve(res);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};
export const deleteData = (url: string) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((res: any) => {
        resolve(res);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};

export const postDataWithToken: any = (
  url: string,
  data: any,
  token: string
) => {
  return new Promise((resolve, reject) => {
    axiosInstanceWithToken
      .post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        baseURL: API_URL,
      })
      .then((res: any) => {
        resolve(res);
      })
      .catch((error: any) => {
        reject(error);
        return error;
      });
  });
};

export const getDataWithoutAbort: any = (url: string, filters?: any) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url, {
        params: filters,
      })
      .then((res: any) => {
        resolve(res);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
};